module.exports = __webpack_public_path__ + "img/uploadNo.ee701074.svg";